import React from 'react';
import { Building2, Briefcase } from 'lucide-react';
import StageChip from './StageChip';

export default function AccountAvatar({ account, showStage = true, className = '' }) {
  if (!account) return null;
  const Icon = account.type === 'external' ? Briefcase : Building2;
  return (
    <div className={`flex items-start gap-2.5 ${className}`}>
      <div className="shrink-0 w-7 h-7 rounded-lg bg-white/[0.04] border border-white/[0.06] flex items-center justify-center text-gray-400">
        <Icon className="w-3.5 h-3.5" />
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-[13px] text-white font-medium truncate">{account.name}</div>
        <div className="flex items-center gap-1.5 mt-0.5">
          {account.typeSchoolDbn && (
            <span className="text-[10px] font-mono text-gray-500">{account.typeSchoolDbn}</span>
          )}
          {showStage && <StageChip stage={account.lifecycleStage} />}
        </div>
      </div>
    </div>
  );
}
